var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof CommonMessages !== "undefined") return resolve();
	__webpack_require__.l("https://qa-static-common.zhihuiya.com/i18n/24.9.0/remoteEntry.no-cache.js", function(event) {
		if(typeof CommonMessages !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "CommonMessages");
}).then(function() { return CommonMessages; });